module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/size-icon-8a7dd126774d50f732f1a9b7eb956e5b.png";